import React from 'react';

const LinkedInAutomationRetrying: React.FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="7 7 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0063 7.00004C16.952 6.99422 18.8332 7.69773 20.2976 8.97889C21.7621 10.26 22.7094 12.031 22.9623 13.9603C23.0261 14.447 22.6833 14.8933 22.1965 14.9571C21.7097 15.0209 21.2634 14.6781 21.1996 14.1913C21.0029 12.6908 20.2661 11.3134 19.1271 10.3169C17.9881 9.32046 16.5249 8.77328 15.0116 8.77781C13.4982 8.78233 12.0384 9.33825 10.9053 10.3415C9.77228 11.3447 9.04371 12.7265 8.856 14.2282C8.66829 15.7299 9.0343 17.2485 9.88553 18.4998C10.7368 19.7511 12.0148 20.6493 13.4805 21.0262C14.9462 21.4031 16.499 21.2329 17.8483 20.5475C18.7831 20.0726 19.5758 19.3729 20.1609 18.5202H17.6365C17.1456 18.5202 16.7476 18.1223 16.7476 17.6314C16.7476 17.1404 17.1456 16.7425 17.6365 16.7425H21.6164C21.6299 16.7421 21.6436 16.7421 21.6572 16.7425H22.081C22.5719 16.7425 22.9699 17.1404 22.9699 17.6314V22.0758C22.9699 22.5667 22.5719 22.9647 22.081 22.9647C21.59 22.9647 21.1921 22.5667 21.1921 22.0758V20.1021C20.4992 20.9388 19.6376 21.6325 18.6534 22.1325C16.9187 23.0137 14.9222 23.2325 13.0378 22.7479C11.1533 22.2633 9.51007 21.1086 8.41563 19.4998C7.3212 17.891 6.85061 15.9385 7.09195 14.0077C7.33329 12.077 8.27002 10.3004 9.72679 9.0105C11.1836 7.72061 13.0605 7.00585 15.0063 7.00004Z"
      fill="#1D4ED8"
    />
  </svg>
);

export default LinkedInAutomationRetrying;
